
import { Route } from '@/app/router'

const Suppliers = () => import('./index.vue')

const SuppliersMeta = {
	sort: 9,
	displayInSidebar: true,
	displayName: 'supplier',
	icon: 'fal truck-loading',
	activeIcon: 'fas truck-loading'
}

const SuppliersProps = ['page', 'perPage']

export default new Route('/suppliers', Suppliers)
	.as('Dashboard:Suppliers')
	.meta(SuppliersMeta)
	.props(SuppliersProps)
	.permissions(['VIEW_OEM_SUPPLIER', 'OEM_ENABLED'])
